export const SIDEBAR_STATE_LOCAL_STORAGE_KEY = 'sidebarState';

export const KONTUR_UNAVAILABLE_DIALOG_LOCAL_STORAGE_KEY =
  'konturUnavailableDialogShown';

export const SystemIconName = {
  main: 'home_outline',
  news: 'advertising_outline',
  process_catalog: 'grid_4_uneven_vertical_outline',
  dropdown_social_life: 'narrative_outline',
  community: 'globe_outline',
  feed: 'globe_outline',
  surveys: 'rectangle_2_horizontal_outline',
  structure: 'vkhrtek_company_page',
  company_events: 'globe_outline',
  dropdown_company_events: 'article_box_outline',
  company_events_paper: 'globe_outline',
  company_policy: 'document_outline',
  company_absences: 'calendar_outline',
  company_vacations: 'vkhrtek_vacations_page',
  company_employees: 'users_3_outline',
  company_candidates: 'user_square_on_square_outline',
  employee_personal: 'user_square_outline',
  employee_events: 'article_box_outline',
  employee_policy: 'document_outline',
  employee_absences: 'calendar_outline',
  employee_payslips: 'wallet_outline',
  employee_vacations: 'vkhrtek_vacations_page',
  employee_competencies: 'user_check_outline',
  dropdown_company_settings: 'gear_outline',
  dropdown_social_services: 'hand_heart_outline',
  employee_review: 'logo_vk_ads_outline',
  company_review: 'logo_vk_ads_outline',
  company_settings: 'globe_outline',
  company_settings_account: 'globe_outline',
  company_settings_widgets_content: 'globe_outline',
  company_settings_event_types: 'globe_outline',
  company_settings_templates: 'globe_outline',
  company_settings_groups: 'globe_outline',
  company_settings_profiles: 'globe_outline',
  company_settings_substitutes: 'globe_outline',
  company_settings_vacations: 'globe_outline',
  company_settings_attorneys: 'globe_outline',
  company_settings_attorneys_users: 'globe_outline',
  company_settings_sign_types: 'globe_outline',
  company_social_news: 'globe_outline',
  company_services: 'globe_outline',
  employee_services: 'globe_outline',
  company_social_categories: 'globe_outline',
  company_target_audience: 'globe_outline',
  company_social_quiz: 'globe_outline',
  company_social_access: 'globe_outline',
  company_business_trips: 'plane_outline',
  employee_business_trips: 'plane_outline',
  favorites: 'bookmark_outline',
} as const;

export const CustomIconName = {
  globe: 'globe_outline',
  document: 'document_outline',
  bookmark: 'bookmark_outline',
  picture: 'picture_outline',
  cup: 'cup_outline',
  briefcase: 'briefcase_outline',
  advertising: 'advertising_outline',
  user: 'user_outline',
  employee: 'user_outline',
  star: 'favorite_outline',
  flash: 'flash_outline',
  hearts: 'hearts_2_outline',
  info: 'info_circle_outline',
  notebook: 'notebook_check_outline',
  video: 'video_square_outline',
  employee_info: 'vkhrtek_employee_info',
  card: 'rectangle_info_outline',
  hat: 'education_outline',
  lightbulb: 'lightbulb_outline',
  thermometer: 'thermometer_outline',
  chain: 'chain',
  phone: 'phone_outline',
  book: 'book_spread_outline',
  building: 'building_outline',
  grid: 'grid_4_uneven_vertical_outline',
} as const;

export const TIMEOUT_FOR_FADE = 400;
